export function validateTwoChar(rule, value) {
    const regex = /[\w\d\S]{2,}/;
    if (value && !regex.test(value)) {
        return Promise.reject(
            "Should be at least 2 characters long."
        );
    }
    return Promise.resolve();
};